import React from "react";
import { Input, Switch, Radio } from "antd";

import "./styles.scss";

const { TextArea } = Input;

const CommonInput = (props) => {
  const {
    suffix,
    value,
    onChange,
    prefix,
    placeholder,
    className,
    defaultValue,
    disabled,
  } = props;

  return (
    <Input
      prefix={prefix}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      suffix={suffix}
      className={`common-input-field ${className || ""}`}
      defaultValue={defaultValue}
      disabled={disabled}
    />
  );
};

const CommonTextAreaInput = (props) => {
  const { value, onChange, placeholder, className, maxRows, minRows } = props;

  return (
    <TextArea
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      className={`common-input-field ${className || ""}`}
      autoSize={{ maxRows, minRows }}
    />
  );
};

const CommonSwitch = (props) => {
  const { pretext, name, posttext, onChange, active } = props;

  return (
    <>
      <div className="common-switch-wrapper">
        <span className={`pre-text ${!active ? "active" : ""}`}>{pretext}</span>
        <Switch {...props} name={name} onChange={onChange} checked={active} />
        <span className={`post-text ${active ? "active" : ""}`}>
          {posttext}
        </span>
      </div>
    </>
  );
};

const CommonRadio = (props) => {
  const { defaultValue, options, handleChange, disabled, value, name } = props;

  const onChange = (e) => {
    handleChange(e);
  };

  return (
    <Radio.Group
      defaultValue={defaultValue}
      onChange={onChange}
      disabled={disabled}
      value={value}
      name={name}
      className="common-radio-field"
    >
      {options.map((data) => (
        <div className="common-radio-option">
          <Radio key={data.value} value={data.value}>
            {data.label}
          </Radio>
        </div>
      ))}
    </Radio.Group>
  );
};

const CommonFields = (props) => {
  const { type } = props;

  if (type === "switch") return <CommonSwitch {...props} />;
  else if (type === "radio") return <CommonRadio {...props} />;
  else if (type === "textarea") return <CommonTextAreaInput {...props} />;
  else return <CommonInput {...props} />;
};

export default CommonFields;
